import React from "react";

function VideoPlay() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47"
      height="47"
      viewBox="0 0 47 47"
    >
      <g id="play" transform="translate(-0.091 0)">
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="23.5"
          cy="23.5"
          r="23.5"
          transform="translate(0.091 0)"
          opacity="0.7"
        />
        <path
          id="Play_Icon"
          data-name="Play Icon"
          d="M21.462,13.879,8.92,22.241A.592.592,0,0,1,8,21.748V5.026a.592.592,0,0,1,.92-.492l12.542,8.361a.592.592,0,0,1,0,.985Z"
          transform="translate(8.728 10.203)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default VideoPlay;
